import { render } from "./TheHeader.vue?vue&type=template&id=114aca88&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=114aca88&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114aca88"]])

export default __exports__